<script>
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';
import { changeLeadStage } from '@/utils/lead';

export default {
  inject: ['setLoading'],
  emits: ['uploaded'],
  data() {
    return {
      lead_id: null,
      stage_id: null,
      name: '',
      document: null,
      errors: {},
      submitting: false,
    };
  },
  methods: {
    open(lead_id, stage_id) {
      this.lead_id = lead_id;
      this.stage_id = stage_id;
      this.name = '';
      this.document = null;
      this.errors = {};
      this.$nextTick(() => {
        const modalEl = document.getElementById('document_upload_modal');
        const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
        modal.show();
      });
    },

    onFileChange(e) {
      this.document = e.target.files[0] || null;
    },

    async submitDocument() {
      if (this.submitting) return;
      this.submitting = true;
      this.errors = {};
      this.setLoading(true);

      try {
        // 1. Upload document
        const formData = new FormData();
        formData.append('client_type', 'App\\Models\\Lead');
        formData.append('client_id', this.lead_id);
        formData.append('name', this.name);
        formData.append('document', this.document);

        await axios.post('/client-documents/upload', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });

        // 2. Change stage after upload
        await changeLeadStage(this.lead_id, this.stage_id);

        this.$swalToast('Document uploaded & stage updated!');
        this.$closeModal('document_upload_modal');
        this.$emit('uploaded');
        this.resetForm();
      } catch (error) {
        if (error.type === 'validation') {
          this.errors = error.errors;
        } else {
          this.$swalToast(error.message, 'error');
        }
      } finally {
        this.submitting = false;
        this.setLoading(false);
      }
    },

    resetForm() {
      this.lead_id = null;
      this.stage_id = null;
      this.name = '';
      this.document = null;
      this.errors = {};
    },
  },
};
</script>

<template>
  <div class="modal fade" id="document_upload_modal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content" style="border:none;border-radius:16px;overflow:hidden;">

        <!-- Header -->
        <div class="modal-header" style="background:linear-gradient(135deg,#0f172a,#1e3a5f);padding:15px 20px;border:none;">
          <div class="d-flex align-items-center gap-2">
            <div style="width:32px;height:32px;background:rgba(255,255,255,.15);border-radius:8px;display:flex;align-items:center;justify-content:center;">
              <i class="ti ti-file-upload" style="color:#fff;font-size:15px;"></i>
            </div>
            <div>
              <h5 class="modal-title" style="font-size:14px;font-weight:700;color:#fff;margin:0;">Upload Document</h5>
              <div style="font-size:11px;color:#94a3b8;">Document is required to change stage</div>
            </div>
          </div>
        </div>

        <!-- Body -->
        <div class="modal-body" style="padding:20px;">
          <div class="mb-3">
            <label class="form-label" style="font-size:11px;font-weight:600;color:#475569;">
              Document Name 
            </label>
            <input type="text" class="form-control" v-model="name" placeholder="Enter document name"
              style="border:1.5px solid #e2e8f0;border-radius:8px;font-size:13px;" />
            <small class="text-danger" v-if="errors.name">{{ errors.name[0] }}</small>
          </div>

          <div class="mb-3">
            <label class="form-label" style="font-size:11px;font-weight:600;color:#475569;">
              Upload File <span class="text-danger">*</span>
            </label>
            <input type="file" class="form-control" @change="onFileChange"
              style="border:1.5px solid #e2e8f0;border-radius:8px;font-size:13px;" />
            <small class="text-danger" v-if="errors.document">{{ errors.document[0] }}</small>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer" style="border-top:1px solid #e2e8f0;padding:11px 20px;gap:8px;">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal"
            style="border-radius:8px;font-size:12px;font-weight:600;">Cancel</button>
          <button type="button" class="btn btn-primary" @click="submitDocument()" :disabled="submitting"
            style="border-radius:8px;font-size:12px;font-weight:600;">
            <i class="ti ti-upload me-1"></i>
            {{ submitting ? 'Uploading...' : 'Upload & Continue' }}
          </button>
        </div>

      </div>
    </div>
  </div>
</template>